import { __rest } from "tslib";
import React from 'react';
import { default as getVariationsFromProps } from "@pb/utils/common/getVariationsFromProps";
import cn from 'classnames';
import styles from './BodyText.module.scss';
const BodyText = (_a) => {
    var { Tag = 'p', className, children, markup, lineClamp } = _a, props = __rest(_a, ["Tag", "className", "children", "markup", "lineClamp"]);
    const [variationsClassNames, restOfProps] = getVariationsFromProps(Object.assign(Object.assign({}, props), (!!lineClamp && { [`lineClamp${lineClamp}`]: true })), styles);
    return (React.createElement(React.Fragment, null, markup ? (React.createElement(Tag, Object.assign({ className: cn(styles.general, className, variationsClassNames), dangerouslySetInnerHTML: { __html: markup } }, restOfProps))) : (React.createElement(Tag, Object.assign({ className: cn(styles.general, className, variationsClassNames) }, restOfProps), children))));
};
export default BodyText;
//# sourceMappingURL=BodyText.js.map